/* eslint-disable no-shadow */
import React, { useEffect, useState, useRef } from 'react'
import { message } from 'antd'
import { useLockFn } from 'ahooks'
import empty from 'image/comment_empty.png'
import qs from 'qs'
import util from 'meinian-package/src/utils/util'
import request from 'meinian-package/src/utils/request'
import { Empty } from 'meinian-package/src/baseComponent'
import Button from 'meinian-package/src/baseComponent/button'
import Comment, { CreateComment, DeleteComment } from 'component/comment'
import { hasCommentAuth } from '../../detailAuth'
import './comment.less'

export default ({
  blogId,
  loginUserInfo,
  createUserId,
  sampleId,
  type,
  collectId,
  onInitCommentTotal,
}) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [comments, setComments] = useState([])
  const [replyTo, setReplyTo] = useState({})
  const [focusFlag, setFocusFlag] = useState(false)
  const [commentText, setCommentText] = useState('')
  const $create = useRef()
  useEffect(() => {
    fetchComments()
  }, [blogId, collectId, sampleId])

  useEffect(() => {
    focusFlag && $create.current.focus()
  }, [focusFlag])

  const fetchComments = async () => {
    const res = await request.get('/zhikuan/ins/inspiration/get-user-comment', {
      params: {
        blogId,
        userId: createUserId,
        collectOrSampleId: type === 0 ? collectId : sampleId,
        type
      }
    })
    setComments(res || [])
  }
  const auth = loginUserInfo?.inspirationPermissions || []
  const commentListWrap = useRef(null)

  useEffect(() => {
    if (query.commentId && comments.length) {
      document.querySelector(`[data-id='${query.commentId}']`).scrollTop = 0
    }
  }, [comments, commentListWrap.current])

  const onPub = useLockFn(async () => {
    await $create.current.create()
    onInitCommentTotal()
    setReplyTo({})
  })

  return <div className="meinian-image-detail-comment">
    <div className="create-comment-wrapper">
      <CreateComment
        ref={$create}
        onInput={(val) => {
          setCommentText(val)
        }}
        blogId={blogId}
        collectOrSampleId={type === 0 ? collectId : sampleId}
        responseId={replyTo.id}
        responseUserId={replyTo.userId}
        responseUserName={replyTo.userName}
        type={type}
        onChange={() => {
          util.track('mn-inspiration-comment', {
          })
          fetchComments()
          onInitCommentTotal()
        }}
        placeholder="输入对当前款式的评论"
      />
      <Button
        type="primary"
        style={{ width: 112, marginLeft: 8, height: '64px', lineHeight: '54px' }}
        onClick={() => onPub()}
        disabled={!commentText.trim().length}
      >
        发布
      </Button>
    </div>
    {comments.length ? <div className="comments-wrap" ref={commentListWrap}>
      {comments.map(comment => <Comment
        key={comment.id}
        data={comment}
        onReply={(_replyTo) => { setReplyTo(_replyTo); setFocusFlag(pre => !pre) }}
        onDelete={(comment) => {
          if (!hasCommentAuth(auth, comment.userId)) {
            message.error('仅可删除自己的评论哦')
            return
          }
          DeleteComment({
            comment,
            blogId,
            type,
            onChange: () => {
              setComments(pre => pre.filter(m => m.id !== comment.id))
              onInitCommentTotal()
            }
          })
        }}
        hiddenDelete={!hasCommentAuth(auth, comment.userId)}
      />)}
    </div>
      : <Empty image={empty} title="还没有人发布评论" style={{ paddingTop: '84px' }} />}
  </div>
}
